export default __webpack_public_path__ + "static/media/0278.5da3d5db.jpg";